import React from 'react';
import cmsUtils from '../cmsUtils';
import { Subscribe } from './subscribe';

export const renderRule = {
  match: (item, cmsOption) => (cmsUtils.getCodeJson(item) || {})['control'] === 'subscribe', 
  itemElt: (item, cmsOption) => <Subscribe />
}